import { render, staticRenderFns } from "./DefaultBuiltInListItem.vue?vue&type=template&id=c70676d8&"
import script from "./DefaultBuiltInListItem.vue?vue&type=script&lang=ts&"
export * from "./DefaultBuiltInListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports